import Account from "@/plugins/api/factories/Account";
import Auth from "@/plugins/api/factories/Auth";
import Settings from "@/plugins/api/factories/Settings";
import appBridge from "@/mixins/app-bridge";
import axios from "axios";
// import api from "@/plugins/api/EntryPoint";
// import router from "@/router";
// import axios from "axios";
// import store from "@/store";

export const state = {
  hidden: false,
  guest: false,
  authLog: "",
  nativeData: null,
  authToken: null,
  appTheme: "dark",
  themeReady: false,
  accounts: {},
  account: null,
  eic: null,
  accountNumber: null,
  accountNumberLsDistrib: null,
  phoneNumber: null,
  locale: process.env.VUE_APP_I18N_DEFAULT_LOCALE,
  status: 0,
  status_sub: 0,
  share_status: 0,
  stripe_payment: 0,
  requestedPage: null,
  user_id: null,
  user_ls: null,
  isPreloaded: false,
  app_id: null,
};

export const mutations = {
  WRITE_AUTH_LOG(state, logString) {
    state.authLog = state.authLog + ";" + logString;
  },
  SET_APP_THEME(state, appTheme) {
    document.body.classList.remove("app-theme-" + state.appTheme);
    state.appTheme = appTheme;
    state.themeReady = true;
    document.body.classList.add("app-theme-" + appTheme);

    Settings.setTheme(appTheme);
  },
  CHANGE_USER_THEME(state, theme) {
    Settings.setTheme(theme);
  },
  SET_REQUESTED_PAGE(state, requestedPage) {
    state.requestedPage = requestedPage;
  },
  SET_ACCOUNT_NUMBER(state, accountNumber) {
    state.accountNumber = accountNumber;
  },
  SET_ACCOUNT_NUMBER_LS_DISTRIB(state, accountNumberLsDistrib) {
    state.accountNumberLsDistrib = accountNumberLsDistrib;
  },
  SET_NATIVE_DATA(state, nativeData) {
    state.nativeData = nativeData;
  },
  SET_AUTH_TOKEN(state, token) {
    state.authToken = token;
  },
  SET_USER_STATUS(state, status) {
    state.status = status;
  },
  SET_STRIPE_PAYMENT(state, stripe_payment) {
    state.stripe_payment = stripe_payment;
  },
  SET_USER_STATUS_SUB(state, status_sub) {
    state.status_sub = status_sub;
  },
  SET_USER_SHARE_STATUS(state, share_status) {
    state.share_status = share_status;
    console.log("SET_USER_SHARE_STATUS: " + JSON.stringify(state.share_status));
  },
  SET_ACCOUNTS(state, accounts) {
    state.accounts = accounts;
  },
  SET_USER_ID(state, user_id) {
    state.user_id = user_id;
  },
  SET_USER_LS(state, user_ls) {
    state.user_ls = user_ls;
  },
  SET_PHONE_NUMBER(state, phoneNumber) {
    state.phoneNumber = phoneNumber;
  },
  SET_LOCALE(state, locale) {
    let locales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(",");
    if (locales.indexOf(locale) >= 0) {
      state.locale = locale;
    } else {
      state.locale = process.env.VUE_APP_I18N_DEFAULT_LOCALE;
    }
  },
  SET_ACCOUNT(state, account) {
    state.account = account;
  },
  SET_EIC(state, account) {
    state.eic = account;
  },
  SET_GUEST(state, guest) {
    state.guest = guest;
  },
  SET_HIDDEN(state, hidden) {
    state.hidden = hidden;
  },
  SET_APP_ID(state, app_id) {
    state.app_id = app_id;
  },
};

export const getters = {
  nativeData(state) {
    return state.nativeData;
  },
};

export const actions = {
  async authenticate({ commit, dispatch }, authData) {
    console.log("SET : authData" + JSON.stringify(authData));
    commit("SET_NATIVE_DATA", authData);
    commit("SET_APP_ID", authData.id);
    commit("Payment/SET_NAME_APP_ID", authData.id, { root: true });
    dispatch("newNativeData");
  },
  authenticateListenApple({ commit, dispatch }, authListenData) {
    commit("SET_NATIVE_DATA", authListenData);
    commit("SET_PLATFORM", authListenData.platform);
    dispatch("newAppleAuth");
  },
  authenticateListenGoogle({ commit, dispatch }, authListenData) {
    commit("SET_NATIVE_DATA", authListenData);
    commit("SET_PLATFORM", authListenData.platform);
    dispatch("newGoogleAuth");
  },
  async storeGuest({ state }, callBackFn) {
    Account.guestMode(state.guest, (res) => {
      callBackFn(res);
    });
  },
  async getGuest({ commit }) {
    await Account.getGuestMode((response) => {
      commit("SET_GUEST", response.guest);
    });
  },
  async setupUserSettings({ dispatch, commit, state }) {
    await Settings.getLanguage(async (lang) => {
      let selectedLocale;
      if (lang.language === null) {
        Settings.putLanguage(state.nativeData.lang);
        selectedLocale = state.nativeData.lang;
      } else {
        selectedLocale = lang.language;
      }
      commit("SET_LOCALE", selectedLocale);
      commit("Settings/UPDATE_LANGUAGE", selectedLocale, { root: true });
    });
    await Auth.getPhoneNumber((response) => {
      commit("SET_PHONE_NUMBER", response.phone);
    });
    dispatch("getAndSetupTheme");
  },
  async setUserPhone({ state, commit }) {
    console.log("TRY TO SET PHONE");
    if (state.authToken !== null && state.authToken !== undefined) {
      await Auth.getPhoneNumber((response) => {
        console.log("SET PHONE: " + response.phone);
        commit("SET_PHONE_NUMBER", response.phone);
        window.Tawk_API.setAttributes({
          phone: response.phone,
          link: "https://support.billing.city/user/" + response.id,
        });
      });
    }
  },
  async getAndSetupTheme({ commit, state }, theme) {
    await Settings.getTheme((res) => {
      console.log("GET AND SETUP THEME");
      state.themeReady = false;
      const themeToSetup = res.theme ? res.theme : theme ? theme : "dark";
      commit("SET_APP_THEME", themeToSetup);
      appBridge.methods.nativeSendEvent("setThemeMode", themeToSetup);
    });
  },
  async refreshToken({ commit }) {
    return Account.refreshToken((response) => {
      commit("SET_AUTH_TOKEN", response.access_token);
    });
  },
  async importAccounts() {
    return Account.importAccounts((res) => {
      return res.mode;
    });
  },
  async getUserAccounts({ commit }) {
    return Account.getAccounts((response) => {
      return commit("SET_ACCOUNTS", response);
    });
  },
  getUserAccount({ commit }, account) {
    return Account.getAccount(account, (response) => {
      console.log("GET USER ACCOUNT CHECK: " + JSON.stringify(response));
      commit("SET_ACCOUNT", response);
      commit("SET_EIC", response);
      commit("Payment/UPDATE_AMOUNT", response.balance, { root: true });
    });
  },
  storeNewAccount({ state }, callBackFn) {
    Account.storeAccount(state.accountNumber, (res) => {
      callBackFn(res);
    });
  },
  storeNewAccountLsDistrib({ state }, callBackFn) {
    Account.storeAccountLsDistrib(
      state.accountNumber,
      state.accountNumberLsDistrib,
      (res) => {
        callBackFn(res);
      }
    );
  },
  storeNewAcontEic({ state }, callBackFn) {
    Account.storeAccountEic(state.accountNumber, (res) => {
      callBackFn(res);
    });
  },
  newNativeData({ state, commit }) {
    Account.nativeAuth(state.nativeData).then((response) => {
      console.log(JSON.stringify(response.data));
      commit("SET_AUTH_TOKEN", response.data.access_token);
      commit("SET_USER_STATUS_SUB", response.data.status);
      commit("SET_USER_SHARE_STATUS", response.data.share_status);
      commit("SET_STRIPE_PAYMENT", response.data.stripe_payment);
      commit("SET_USER_ID", response.data.user_id);
      console.log("USER STATUS SUB: " + response.data.status);
    });
  },
  newGoogleAuth({ state, commit }) {
    Account.googleAuth(state.nativeData).then((response) => {
      console.log(JSON.stringify(response.data));
      commit("SET_AUTH_TOKEN", response.data.access_token);
      commit("SET_USER_STATUS_SUB", response.data.status);
      commit("SET_USER_SHARE_STATUS", response.data.share_status);
      commit("SET_STRIPE_PAYMENT", response.data.stripe_payment);
      commit("SET_USER_ID", response.data.user_id);
      console.log("USER STATUS SUB: " + response.data.status);
    });
  },
  newAppleAuth({ state, commit }) {
    Account.appleAuth(state.nativeData).then((response) => {
      console.log(JSON.stringify(response.data));
      commit("SET_AUTH_TOKEN", response.data.access_token);
      commit("SET_USER_STATUS_SUB", response.data.status);
      commit("SET_USER_SHARE_STATUS", response.data.share_status);
      commit("SET_STRIPE_PAYMENT", response.data.stripe_payment);
      commit("SET_USER_ID", response.data.user_id);
      console.log("USER STATUS SUB: " + response.data.status);
    });
  },
  deleteUserAccount({ dispatch }, accountNumber) {
    return Account.deleteAccountByNumber(accountNumber, () => {
      dispatch("getUserAccounts");
    });
  },
  deleteUser(callBackFn) {
    return Account.deleteUser((res) => {
      callBackFn(res);
    }).then(() => {
      this.$forceUpdate();
    });
  },
  getUserLanguage({ commit }) {
    return Settings.getLanguage((response) => {
      return commit("SET_LOCALE", response);
    });
  },
  async getSubscriptionStatus({ commit }) {
    await Account.getSubscriptionStatus((response) => {
      if (response.status === 0 || response.status === 2) {
        commit("SET_USER_STATUS_SUB", 0);
      } else {
        commit("SET_USER_STATUS_SUB", 1);
      }
      localStorage.setItem("user_status", response.status);
      return commit("SET_USER_STATUS", response.status);
    });
  },
  async getStripeStatus({ commit }) {
    await Account.getStripeStatus((response) => {
      commit("SET_STRIPE_PAYMENT", response.status);
    });
  },

  getUserLS({ commit }, data) {
    return axios(`https://proc.billing.city/api/get-ls/${data.ls}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        commit("SET_USER_LS", response.data.ls);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
